import React, { Component } from "react";
import NumberFormat from "react-number-format";
import { mensajeExito } from "../../../generico/MensajeSistemaToast";
import { trackPromise } from "react-promise-tracker";
import TransferExpressService from "../../../../services/transferencias/TransferXpressService";
import AuthService from "../../../../services/login/auth.service";
import MensajeUsuario from "../../../generico/MensajeUsuario";
import TransferInterentidadService from "../../../../services/transferencias/TransferInterentidadService";
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faPlus, faFilePdf} from "@fortawesome/free-solid-svg-icons";
const tokenActivo = sessionStorage.getItem('tieneToken');
export default class TransferenciaInterentidad extends Component {
  constructor(props) {
    super(props);
  }

  descargar = async () => {

    // console.log("DESCARGAR transferencia por: " + this.props.intermediario);

    if (this.props.intermediario.toLowerCase() === "basa") {

      await trackPromise(
        TransferInterentidadService.descagarComponente(
          "Interbancarias via SIPAP",
          this.props.nroOperacion,
          this.props.cuentaOrigen.ahorro +
          " - " +
          AuthService.getSocio().nombreCompleto.trim(),
          this.props.cuentaOrigen.descripcion,
          this.props.cuentaOrigen.moneda,
          this.props.cuentaOrigen.ahorro,
          this.props.cuentaDestino.nroCuenta,
          this.props.importe,
          this.props.importe,
          this.props.cuentaDestino.titular,
          this.props.cuentaDestino.entidad,
          this.props.cuentaDestino.tipoDocDestino,
          this.props.cuentaDestino.docDestino,
          this.props.motivo
        )
          .then((response) => {
            var fileURL = URL.createObjectURL(response.data);
            window.open(fileURL, "");
          })
          .catch(function (error) {
            console.log(error);
          })
      );

    } else {
      var data = JSON.stringify({
        titulo: "Transferencias Interbancarias",
        nroOperacion: this.props.nroOperacion,
        cuentaTitular:
          this.props.cuentaOrigen.ahorro +
          " - " +
          AuthService.getSocio().nombreCompleto.trim(),
        tipo: this.props.cuentaOrigen.descripcion,
        moneda: this.props.cuentaOrigen.moneda,
        cuentaCredito: this.props.cuentaDestino.nroCuenta,
        importeDebito: this.props.importe + " " + this.props.cuentaOrigen.moneda,
        importeCredito: this.props.importe + " " + this.props.cuentaOrigen.moneda,
        titularCuentaDestino: this.props.cuentaDestino.titular,
        entidad: this.props.cuentaDestino.entidad,
        motivo: this.props.motivo,
        // celularDestinatario: this.controlCelular() === true ? this.props.celular : "N/A",
        celularDestinatario: "N/A",
        fechaOperacion: new Date().toLocaleDateString("es-ES", {
          year: "numeric",
          month: "numeric",
          day: "numeric",
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
        }),
      });

      await trackPromise(
        TransferExpressService.descagarComprobante(data)
          .then((response) => {
            var fileURL = URL.createObjectURL(response.data);
            window.open(fileURL, "");
          })
          .catch(function (error) {
            console.log(error);
          })
      );
    }


  };



  render() {
    if (this.props.currentStep === 5) {
      mensajeExito("La Transferencia se Realizó Correctamente");
    }

    return (
      <div>
        <div className="row">
          <div className="steps clearfix">
            <ul role="tablist">
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text current">
                      Selección de Cuentas
                    </span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Datos de Transferencia</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Datos de Verificación</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Código de Verificación</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="current last">
                <span>
                  <div className="title">
                    <span className="title_text">Confirmación</span>
                  </div>
                </span>
              </li>
            </ul>
          </div>
        </div>
        <div className="row justify-content-md-center">
          <div className="col-lg-8 col-md-10">
            <p className="nro-operacion">
              Número de Operación: {this.props.nroOperacion}
            </p>
          </div>
        </div>
        <div className="row justify-content-md-center">
          <div className="col-lg-8 col-md-10">
            <div className="invoice p-3 mb-3">
              <div className="row">
                <div className="col-8" style={{ marginBottom: 5 }}>
                  <h6 className="item-vef" style={{ margin: 0 }}>
                    Cuenta: {this.props.cuentaOrigen.ahorro} -{" "}
                    {AuthService.getSocio().nombreCompleto.trim()}
                  </h6>
                  <p className="item-vef" style={{ marginBottom: 0 }}>
                    Tipo: {this.props.cuentaOrigen.descripcion}
                  </p>
                  <p className="item-vef">Moneda: {this.props.cuentaOrigen.moneda}</p>
                </div>
              </div>
              <div className="row invoice-info">
                <div className="col-12">
                  <div className="table-responsive">
                    <table className="table">
                      <tbody>
                      {(this.props.cuentaDestino.alias!==null) && ( 
                        <tr>
                          <th>Alias:</th>
                          <td>{this.props.cuentaDestino.alias}</td>
                        </tr>
                        )}
                        <tr>
                          <th>Cuenta Crédito:</th>
                          <td>{this.props.cuentaDestino.nroCuenta}</td>
                        </tr>
                        <tr>
                          <th>Importe del Crédito:</th>
                          <td>
                            <NumberFormat
                              value={this.props.importe}
                              displayType={"text"}
                              decimalSeparator={","}
                              thousandSeparator={"."}
                            />{" "}
                            {this.props.cuentaOrigen.moneda}.
                          </td>
                        </tr>
                        <tr>
                          <th>Titular de la cuenta destino:</th>
                          <td>{this.props.cuentaDestino.titular}</td>
                        </tr>
                        <tr>
                          <th>Tipo documento de la cuenta destino:</th>
                          <td>{this.props.cuentaDestino.tipoDocDestino}</td>
                        </tr>
                        <tr>
                          <th>Documento de la cuenta destino:</th>
                          <td>{this.props.cuentaDestino.docDestino}</td>
                        </tr>
                        <tr>
                          <th>Entidad:</th>
                          <td>{this.props.cuentaDestino.entidad}</td>
                        </tr>
                        <tr>
                          <th>Motivo:</th>
                          <td>{this.props.motivo}</td>
                        </tr>
                        <tr>
                          <th>Fecha de Operación:</th>
                          <td>
                            {new Date().toLocaleDateString("es-ES", {
                              year: "numeric",
                              month: "numeric",
                              day: "numeric",
                              hour: "numeric",
                              minute: "numeric",
                              second: "numeric",
                            })}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className="row invoice-info">
                <div className="col-12">
                  <div className="row">
                    <div className="col-md-12">
                      {
                        this.props.intermediario.toLowerCase() === "basa" &&
                        <div
                          className="callout callout-success"
                          style={{
                            border: "2px solid #E30A0A",
                            backgroundColor: "#ffffff00",
                            boxShadow: "none",
                          }}
                        >
                          <div className="row">
                            <div className="col-md-12">
                              <i
                                className="fas fa-exclamation-circle card-fa-icono-info"
                                style={{ marginRight: 5, fontSize: 25 }}
                              />
                              <p style={{ fontSize: 20 }}>Importante!</p>
                            </div>
                          </div>
                          <div className="row">
                          {
                        tokenActivo === "S" ?
                            <div className="col-md-12">
                              - El horario de SIPAP para envío de transacciones es
                              de 09:00hs a 17:00hs. Los pagos enviados posterior
                              al horario de SIPAP serán procesados al siguiente
                              día hábil.
                              <br />
                              - El límite diario es de 30.000.000 Gs. y el límite
                              mensual es de 150.000.000 Gs
                              <br />
                              - Cantidad de operaciones sin costo: 7<br />
                              - Monto a descontar al exceder las 7 operaciones:
                              5.500 Gs.
                              <br />
                              - Todas las operaciones realizadas son de exclusiva
                              responsabilidad del socio, en caso de errores en la
                              imputación de las transferencias, las reversiones
                              dependen de la aprobación de la entidad receptora.
                              <br />
                            </div>
                            :
                            <div className="col-md-12">
                            - El horario de SIPAP para envío de transacciones es
                            de 09:00hs a 17:00hs. Los pagos enviados posterior
                            al horario de SIPAP serán procesados al siguiente
                            día hábil.
                            <br />
                            - El límite diario es de 10.000.000 Gs. y el límite
                            mensual es de 50.000.000 Gs
                            <br />
                            - Cantidad de operaciones sin costo: 7<br />
                            - Monto a descontar al exceder las 7 operaciones:
                            5.500 Gs.
                            <br />
                            - Todas las operaciones realizadas son de exclusiva
                            responsabilidad del socio, en caso de errores en la
                            imputación de las transferencias, las reversiones
                            dependen de la aprobación de la entidad receptora.
                            <br />
                          </div>
                            }
                          </div>
   
                        </div>
                      }
                      {
                        this.props.intermediario.toLowerCase() === "cabal" &&
                        <div className="col-md-12">
                          <MensajeUsuario
                            tipo="INFO"
                            titulo="Importante!"
                            mensaje="- El límite diario es de 6.000.000 Gs. (establecido por Bancard)."
                            mensaje2="- Todas las operaciones realizadas son de exclusiva
                    responsabilidad del socio, en caso de errores en la imputación de
                    las transferencias, las reversiones dependen de la aprobación de
                    la entidad receptora."
                          />
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col-lg-6 col-md-6"></div>
          <div className="col-lg-3 col-md-3 btn-consulta">
          <button
            hidden
            ref={(a) => (this.nextStep = a)}
            onClick={this.props.firstStep}
          ></button>
          <button
            className="btn btn-cu-quintary"
            onClick={(e) => {
              this.props.returnDataPaso5();
              this.nextStep.click();
            }}
          >
          <FontAwesomeIcon icon={faPlus} />  Nueva Transacción
          </button>
          </div>
          <div className="col-lg-3 col-md-3">
          <button className="btn btn-cu-primary" onClick={this.descargar}>
          <FontAwesomeIcon icon={faFilePdf} />  Descargar Comprobante
          </button>
          </div>
        </div>
      </div>
    );
  }
}
